

import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";

import { AppSettings } from "../../shared/app-settings";
import { INofesh } from "../../nofesh/model/nofesh";
import { CommonModule, DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NofeshPricesComponent } from "../../shared/nofesh-prices/nofesh-prices.component";
import { IPrice } from 'app/nofesh/admin/model/price';
import { ENofeshStatus } from '../../shared/enums/enofesh-status.enum';
import { ENofeshType } from '../../shared/enums/enofesh-type.enum';
import { ConfigService } from 'app/shared/config.service';
import { NofshonimService } from '../nofshonim.service';

@Component({
    moduleId: module.id,
    templateUrl: './nofshon-chul-details.component.html',
    styleUrls: ['./nofshon-chul-details.component.css']
})

export class NofeshChulDetailsComponent implements OnInit, OnDestroy {
    apiUrl: string = "";
    nofesh: INofesh;
    nofeshId: number;
    nofesh_syllabus_file_url: string;
    is_tkufat_rishum: boolean = false;
    //המלאי אזל אין מקומות בהמתנה
    is_nofesh_full: boolean = false;
    is_nofesh_hamtana: boolean = false;
    is_user_selected_another_nofesh: boolean = false;
    isRegistedByOtherAmit: boolean = false;
    //should_check_zakaut: boolean = true;
    registeredToThisNofesh: boolean = false;
    is_user_selected_mimush_all: boolean = false;
    is_user_selected_mimush_one: boolean = false;
    is_user_selected_only_one_zakaut: boolean = false;
    currentTime: Date;
    constructor(private _activateRoute: ActivatedRoute, private _router: Router, private _configService: ConfigService, private _nofshonimService: NofshonimService) {
        this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
        this.nofesh_syllabus_file_url = `${this.apiUrl}/UploadFiles/NofeshSyllabus/`;
    }

    ngOnInit() {
        console.log("this.apiUrl", this.apiUrl);
        console.log("nofesh_syllabus_file_url", this.nofesh_syllabus_file_url);

        let todaysDate1 = new Date(new Date().toUTCString());

        // document.getElementById('menuDiv').style.display = 'none'; 
        this.nofeshId = this._activateRoute.snapshot.params['id'];
        if (this.nofeshId == null || this.nofeshId == undefined || this.nofeshId == 0) {
            this._router.navigateByUrl('/nofesh');
            return;
        }



        let nofashim = JSON.parse(sessionStorage.getItem('nofashim'));
        if (nofashim == null) {
            this._router.navigateByUrl('/nofesh');
            return;
        }

        this.nofesh = <INofesh>nofashim.filter(r => r.id_nofesh == this.nofeshId)[0];
        if (!this.nofesh) {
            this._router.navigateByUrl('/nofesh');
            return;
        }





        let userSelectedNofesh = JSON.parse(sessionStorage.getItem('userSelectedNofesh'));
        if (userSelectedNofesh != null) {
            // no_zakaut_check value 1 means that the nofesh is not using zakaut and the amit can submit for it even if he submitted for 
            //another nofesh or was registered by other amit.
            let canSubmitAnotherNofesh: boolean = Boolean(this.nofesh.no_zakaut_check) || Boolean(userSelectedNofesh.no_zakaut_check);
            if (userSelectedNofesh.id_nofesh > 0 && userSelectedNofesh.id_nofesh != this.nofeshId && !canSubmitAnotherNofesh) {
                // This value is true only if current nofesh and previously selected nofesh no_zakaut_check properties are both 0.
                // In every other case, the amit can place multiple nofashim (meurgan or nofshon).
                if (userSelectedNofesh.mimush == 1) {
                    this.is_user_selected_mimush_one = true;
                    //עובדי איכילוב
                    if (userSelectedNofesh.amuta_kidum == 1) {
                        this.is_user_selected_mimush_one = false;
                        this.is_user_selected_only_one_zakaut = true
                    }
                }

                if (userSelectedNofesh.mimush >= 2) {
                    this.is_user_selected_mimush_all = true;
                    this.is_user_selected_another_nofesh = true;
                }
            }

            // If amit selected this nofesh.
            if (userSelectedNofesh.id_nofesh > 0 && userSelectedNofesh.id_nofesh == this.nofeshId) {
                this.registeredToThisNofesh = true;
            }

            if (userSelectedNofesh.rishum_by_other_id == this.nofesh.id_nofesh) {
                this.registeredToThisNofesh = true;
            }

            else if (userSelectedNofesh.isRegistedByOtherAmit && !canSubmitAnotherNofesh) {
                this.isRegistedByOtherAmit = true;
            }
        }

        //let todaysDate = new Date().setHours(0,0,0,0);
        let todaysDate = new Date(new Date().toUTCString()).getTime();
        let rishum_from = new Date(this.nofesh.fromTkufatRishum);
        let rishum_to = new Date(this.nofesh.toTkufatRishum);




        //this.is_tkufat_rishum = (todaysDate >= rishum_from.setHours(0,0,0,0)) && (todaysDate <= rishum_to.setHours(0,0,0,0));
        // this.is_tkufat_rishum = (this.currentTime.getTime() >= rishum_from.getTime()) && (todaysDate <= rishum_to.getTime());
        this.is_tkufat_rishum = (todaysDate >= rishum_from.getTime()) && (todaysDate <= rishum_to.getTime());
        this.is_nofesh_full = this.nofesh.nofesh_status == ENofeshStatus.AzalHaMelay; //(this.nofesh.reshumim_count >= this.nofesh.total_peaple && this.nofesh.mamtinim_count >= this.nofesh.total_hamtana_people)        
        this.is_nofesh_hamtana = this.nofesh.nofesh_status == ENofeshStatus.Hamtana; //(this.nofesh.reshumim_count >= this.nofesh.total_peaple && this.nofesh.mamtinim_count < this.nofesh.total_hamtana_people);

        return
        //
        // code below not in use.
        // the purpose is not clear - update the object in session and never use it again?
        // this should be deleted
        let noofshonDetails = sessionStorage.getItem('nofeshonDetails_' + this.nofeshId)
        if (!noofshonDetails || noofshonDetails.length == 0) {
            let storageDetailsObj = {
                nofeshTitle: this.nofesh.nofeshTitle,
                nofesh_type: this.nofesh.nofeshType,
                todaysDate: todaysDate,
                rishum_from: rishum_from,
                rishum_to: rishum_to,
                fromTkufatRishum: this.nofesh.fromTkufatRishum,
                toTkufatRishum: this.nofesh.toTkufatRishum,
                is_tkufat_rishum: this.is_tkufat_rishum,
                is_nofesh_full: this.is_nofesh_full,
                is_nofesh_hamtana: this.is_nofesh_hamtana
            }
            sessionStorage.setItem('nofeshonDetails_' + this.nofeshId, JSON.stringify(storageDetailsObj));
        }
        //
    }

    order(event): void {
        event.preventDefault();

        switch (this.nofesh.nofeshType) {
            case ENofeshType.NofeshPnim:
            case ENofeshType.MeurganimPnim:
                this._router.navigate(['nofesh-pnim/order/' + this.nofeshId]);
                break;
            case ENofeshType.NofeshChul:
                this._router.navigate(['nofshonim-chul/order/' + this.nofeshId]);
                break;
            case ENofeshType.MishpachotChul:
                this._router.navigate(['mishpachot-chul/order/' + this.nofeshId]);
                break;
        }
    }

    onNofeshPricesChange(prices: IPrice[]): void {
        sessionStorage.setItem(`nofshonPrices_${this.nofeshId}`, JSON.stringify(prices));
    }

    ngOnDestroy(): void {
        sessionStorage.removeItem(`nofshonPrices_${this.nofeshId}`);
    }
}
